import { AuthEffects } from './auth/auth.effects';

export const rootEffects = [AuthEffects];
